import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "store";
import { get } from "lodash";
import request from "utils/request";

type Status = "idle" | "loading" | "success" | "error";

export interface PayloadActionGetListDedicatedServer {
  region: string;
  site_name: string;
}

export interface PayloadActionListDedicatedServerDetail {
  id: number;
  slug: string;
  name: string;
  description: string;
  price: number;
  cpu: string;
  ram: string;
  ssd: string;
  bandwidth: string;
  ethernet_port: string;
  ipv4: string;
  status: string;
  featured: boolean;
}

interface GetListDedicatedServerState {
  listDedicatedServerDetail: PayloadActionListDedicatedServerDetail[];
  paramsListDedicatedServerDetail: PayloadActionGetListDedicatedServer;
  statusLoadListDedicatedServerDetail: Status;
}

const initialState: GetListDedicatedServerState = {
  listDedicatedServerDetail: [],
  paramsListDedicatedServerDetail: {
    region: "",
    site_name: ''
  },
  statusLoadListDedicatedServerDetail: "idle",
};

export const actionGetListDedicatedServer = createAsyncThunk(
  "listDedicatedServer/actionGetListDedicatedServer",
  async (params: PayloadActionGetListDedicatedServer, { rejectWithValue }) => {
    try {
      const response = await request({
        url: "api/plan/dedicate",
        method: "GET",
        params,
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const slice = createSlice({
  name: "dedicatedServerDetail",
  initialState,
  reducers: {
    actionResetStatus(state) {
      state.statusLoadListDedicatedServerDetail = "idle";
    },
    actionResetStore() {
      return { ...initialState };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(actionGetListDedicatedServer.pending, (state) => {
        state.statusLoadListDedicatedServerDetail = "loading";
      })
      .addCase(actionGetListDedicatedServer.fulfilled, (state, action) => {
        state.statusLoadListDedicatedServerDetail = "success";
        state.listDedicatedServerDetail = get(action, "payload.data").map(
          (item: PayloadActionListDedicatedServerDetail) => ({ ...item })
        );
      })
      .addCase(actionGetListDedicatedServer.rejected, (state) => {
        state.statusLoadListDedicatedServerDetail = "error";
      });
  },
});

export const { actionResetStatus, actionResetStore } = slice.actions;

export const selectListDedicatedServerDetail = (state: RootState) =>
  state.dedicatedServerDetail.listDedicatedServerDetail;
export const selectLoadingListDedicatedServerDetail = (state: RootState) =>
  state.dedicatedServerDetail.statusLoadListDedicatedServerDetail;

export default slice.reducer;
